import React from 'react'
import { Project } from 'src/core/models'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import ProjectDetailsCollapse from '../ProjectDetailsCollapse/ProjectDetailsCollapse'

interface PropsType { project: Project }

const ProjectTaxReliefDetails: React.FC<PropsType> = ({ project }) => {
  const { t, i18n: { language } } = useTranslation()

  const descriptionTax = {
    en: project?.tax_info_en,
    es: project?.tax_info_es,
    fr: project?.tax_info_fr,
    ko: project?.tax_info_ko,
    pt: project?.tax_info_pt,
    de: project?.tax_info_de,
    it: project?.tax_info_it
  }[language] || null

  const isTaxInfoVisible = project.is_contribution_kind && project.is_tax_relief && descriptionTax

  return (
    <>
      {isTaxInfoVisible && (
        <ProjectDetailsCollapse label={<CustomText label={t('Projects.Fields.FiscalInformation')} strong/>}>
          <div dangerouslySetInnerHTML={{
            __html: descriptionTax
          }}
          />
        </ProjectDetailsCollapse>
      )}
    </>
  )
}

export default ProjectTaxReliefDetails
